import React from 'react';
import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import 'firebase/compat/auth'
import { db } from '../../firebase'
import { deleteDoc ,doc } from "firebase/firestore";

firebase.initializeApp({
    apiKey: "AIzaSyDaTbOJkxcyn_XwPlup2ZicYKtqBtRwpY0",
    authDomain: "lipo-kart.firebaseapp.com",
    projectId: "lipo-kart",
    storageBucket: "lipo-kart.firebasestorage.app",
    messagingSenderId: "568534822854",
    appId: "1:568534822854:web:803cafde94ca350bbeccc7",
    measurementId: "G-J147CD0ZTK"
})
const firestore = firebase.firestore()
const user = firebase.auth()
const booking = firestore.collection("Bookings")

function SubmitForm(data) {
    // console.log(itemCount, bookingData)
  const handleSubmit = async (event) => {
    event.preventDefault();
    // Perform actions when the form is submitted
    // You can submit data to a server, handle user input, etc.
    console.log(user.currentUser)
    if(!user.currentUser){
      window.location.href = '/login';
   }
   console.log( data)
    console.log(  {
    detail: data.bookingData.detail,
    phoneNumber: user.currentUser.phoneNumber ?? "",
    email: user.currentUser.email ?? "",
    uid: user.currentUser.uid,
    name: data.bookingData.name,
    price:data.bookingData.price,
    img:data.bookingData.img,
  })

    await booking.add(
      {
        detail: data.bookingData.detail,
        phoneNumber: user.currentUser.phoneNumber ?? "",
        email: user.currentUser.email ?? "",
        uid: user.currentUser.uid,
        name: data.bookingData.name,
        img: data.bookingData.img,
        price:data.bookingData.price * data.itemCount,
        itemCount:data.itemCount,
        bookingDone: false,
        paymentDone: false
      }
    ).then(()=>{
        console.log("booking submited successfully")
    })

  };

  return (
    <form onSubmit={handleSubmit}>
      {/* Other form fields go here */}      
      {/* Submit button */}
      <button className='btn btn-primary btn-sm mb-2' type="submit">Submit</button>
    </form>
  );
}


function RemoveBooking(id) {
  // Define a function to be executed when the button is clicked
  const handleClick = async () => {
  console.log(id.id)
    const documentRef = doc(db, 'Bookings', id.id);

    try {
      await deleteDoc(documentRef);
      console.log('Document successfully deleted');
    } catch (error) {
      console.error('Error deleting document: ', error);
    }

  };
  return (
    <div>
      <button onClick={handleClick}className='btn btn-danger btn-sm'>Remove</button>
    </div>
  );
}


export  {SubmitForm,RemoveBooking};
